import styled, { keyframes } from 'styled-components'

const animation = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  
  100% {
    transform: translate3d(calc(-80px - 127px - 144px - 111px - 112px - 104px - 86px - 102px - 197px - 50px * 7), 0, 0);
  }
`

const mobileAnimation = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  
  100% {
    transform: translate3d(calc(-125px - 71px - 81px - 77px - 74px - 96px - 73px - 74px - 82px - 22px * 7),0,0);
  }
`

export const Root = styled.div`
  width: 100%;
  height: 119px;
  position: relative;
  overflow: hidden;

  font-family: Helvetica Neue;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;

  @media only screen and (max-width: 1000px) {
    padding: 26px;
  }
`

export const Scroll = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  & > * {
    flex-shrink: 0;
  }

  @media only screen and (max-width: 1540px) {
    justify-content: flex-start;
    animation: ${animation};
    animation-duration: 25s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    & span {
      display: none;
    }

    @media only screen and (max-width: 1000px) {
      animation: ${mobileAnimation};
      animation-duration: 17s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      gap: 22px;
      & img {
        max-height: 40px;
      }
    }
  }
`
